module.exports = __webpack_public_path__ + "static/media/landelijk.24dc1e75.jpg";